module.exports = __webpack_public_path__ + "img/about-shape1.fac27986.png";